var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 24.4949C18.6274 24.4949 24 19.1223 24 12.4949C24 5.86746 18.6274 0.494873 12 0.494873C5.37258 0.494873 0 5.86746 0 12.4949C0 19.1223 5.37258 24.4949 12 24.4949Z",
    fill: "url(#paint0_linear_3060_2563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.75 7.9949C15.6014 7.9949 15.4561 8.03905 15.3327 8.12173C15.2092 8.20442 15.1131 8.32192 15.0565 8.45932C14.9999 8.59672 14.9854 8.74783 15.0149 8.89348C15.0443 9.03912 15.1164 9.17275 15.2219 9.27738C15.3274 9.38202 15.4616 9.45296 15.6075 9.4812C15.7534 9.50944 15.9043 9.49371 16.0413 9.436C16.1782 9.37829 16.2949 9.28121 16.3766 9.15707C16.4582 9.03293 16.5012 8.88733 16.5 8.73874C16.5 8.64054 16.4805 8.54331 16.4428 8.45266C16.405 8.36201 16.3497 8.27973 16.2799 8.21058C16.2102 8.14143 16.1275 8.08676 16.0365 8.04975C15.9456 8.01273 15.8482 7.99409 15.75 7.9949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0066 9.11988C11.3388 9.11857 10.6856 9.3154 10.1298 9.68546C9.57388 10.0555 9.14027 10.5822 8.88381 11.1987C8.62735 11.8153 8.55957 12.4941 8.68905 13.1493C8.81853 13.8044 9.13944 14.4064 9.61118 14.879C10.0829 15.3517 10.6843 15.6738 11.3391 15.8045C11.994 15.9353 12.6729 15.8688 13.29 15.6136C13.9071 15.3583 14.4346 14.9258 14.8057 14.3706C15.1769 13.8155 15.375 13.1627 15.375 12.4949C15.375 11.6009 15.0203 10.7435 14.3888 10.1107C13.7573 9.47798 12.9006 9.12163 12.0066 9.11988ZM12.0066 14.6546C11.5776 14.6559 11.1578 14.5298 10.8006 14.2923C10.4433 14.0547 10.1646 13.7165 9.99984 13.3204C9.83505 12.9242 9.7916 12.4881 9.87498 12.0673C9.95835 11.6464 10.1648 11.2598 10.4682 10.9565C10.7715 10.6531 11.1582 10.4466 11.579 10.3632C11.9998 10.2799 12.436 10.3233 12.8321 10.4881C13.2282 10.6529 13.5665 10.9316 13.804 11.2888C14.0415 11.6461 14.1676 12.0659 14.1663 12.4949C14.1646 13.0671 13.9365 13.6155 13.5318 14.0201C13.1272 14.4248 12.5789 14.6529 12.0066 14.6546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.8445 19.6199H9.1555C8.0208 19.6181 6.93309 19.1658 6.13074 18.3623C5.32838 17.5588 4.87682 16.4695 4.875 15.3332V9.66345C4.875 8.52591 5.32576 7.43487 6.12831 6.62986C6.93086 5.82486 8.01961 5.3717 9.1555 5.36987H14.8445C15.9804 5.3717 17.0691 5.82486 17.8717 6.62986C18.6742 7.43487 19.125 8.52591 19.125 9.66345V15.3607C19.1159 16.4923 18.6612 17.5745 17.8596 18.3721C17.058 19.1697 15.9745 19.6181 14.8445 19.6199ZM9.1555 6.7185C8.37558 6.7185 7.6276 7.02877 7.07611 7.58105C6.52462 8.13334 6.2148 8.8824 6.2148 9.66345V15.3607C6.2148 16.1417 6.52462 16.8908 7.07611 17.4431C7.6276 17.9954 8.37558 18.3057 9.1555 18.3057H14.8445C15.6244 18.3057 16.3724 17.9954 16.9239 17.4431C17.4754 16.8908 17.7852 16.1417 17.7852 15.3607V9.66345C17.7852 8.8824 17.4754 8.13334 16.9239 7.58105C16.3724 7.02877 15.6244 6.7185 14.8445 6.7185H9.1555Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3060_2563",
    x1: 0.759751,
    y1: 2.99798,
    x2: 24.753,
    y2: 23.2671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCBB45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F75274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D53692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#8F39CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4FE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/Insta.5450ad1199282bed2116ace43a875c93.svg";
export { ForwardRef as ReactComponent };